export default function (state) {
    return state[state.type];
}